import { CheckCircleIcon, InfoCircleIcon, TimesCircleIcon } from '@wkda/icons';
import cx from 'classnames';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function AlertBox(_ref) {
  let {
    children,
    variant,
    className,
    design = 'complete'
  } = _ref;
  const isSimple = design === 'simple';
  const isComplete = design === 'complete';
  const iconClassName = cx({
    'alert-box-simple__icon': isSimple,
    'alert-box-complete__icon': isComplete
  });
  return /*#__PURE__*/_jsxs("div", {
    className: cx('alert-box d-flex relative align-items-center', className, {
      'alert-box-simple': isSimple,
      'alert-box-complete': isComplete,
      'alert-box-simple--success': isSimple && variant === 'success',
      'alert-box-simple--error': isSimple && variant === 'error',
      'alert-box-simple--info': isSimple && variant === 'info',
      'alert-box-complete--success': isComplete && variant === 'success',
      'alert-box-complete--error': isComplete && variant === 'error',
      'alert-box-complete--info': isComplete && variant === 'info'
    }),
    children: [/*#__PURE__*/_jsxs("div", {
      className: "alert-box__icon-container",
      children: [variant === 'success' && /*#__PURE__*/_jsx(CheckCircleIcon, {
        className: iconClassName
      }), variant === 'error' && /*#__PURE__*/_jsx(TimesCircleIcon, {
        className: iconClassName
      }), variant === 'info' && /*#__PURE__*/_jsx(InfoCircleIcon, {
        className: iconClassName
      })]
    }), /*#__PURE__*/_jsx("div", {
      className: cx({
        'alert-box-simple__content': isSimple,
        'alert-box-complete__content': isComplete
      }),
      children: children
    })]
  });
}